import { currentUserClient } from 'shared/domain/currentUser/currentUserClient';
import { subscribeToCurrentUserIdentity } from 'setup/logger/currentUserIdentity';
import { isDevEnv } from 'shared/utils/environment/determineEnvironment';
import { getServiceWorkerContainer } from './serviceWorkerContainer';

/**
 * Resolves whether anything will listen to the worker's channels: the services
 * running on the page itself (development without the worker), or an active
 * worker. That is at once for a registered worker, and once a first visit
 * registered it. A page that never gets one (blocked registration, a crawler)
 * keeps waiting and sends nothing, so nothing is left unacknowledged.
 */
async function waitForListeningWorker(): Promise<boolean> {
  if (isDevEnv()) {
    return true;
  }
  const container = getServiceWorkerContainer();
  if (!container) {
    return false;
  }
  await container.ready;
  return true;
}

/**
 * Keeps the worker told who is logged in, so its logs name the user from
 * its start, not only once it downloaded the permissions.
 */
export function announceCurrentUserToServiceWorker(): () => void {
  return subscribeToCurrentUserIdentity((identity) => {
    void waitForListeningWorker().then((isListening) => {
      if (isListening) {
        currentUserClient.identify(identity);
      }
    });
  });
}
